import React from "react";
import { useEffect } from "react";
import { Router, useNavigate } from "react-router-dom";

function Error() {

    let navigate = useNavigate();
    useEffect(() => {
        setTimeout(() => {
            navigate("/");
        }, 5000);
    }, [])

    return (
        <div className="abstract">
            <h2 className="compTitle" style={{color: 'red'}}>Registration form couldn't be submitted</h2>
            <h2 className="compTitle">Try again after some time.</h2>
            <br/><br/>
            <p style={{textAlign: 'center'}}>Redirecting back to Home</p>
        </div>
    )
}

export default Error;